(ns teamoesterreich.admin-mode.toe-map-search.maps-element
  (:require [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.detail-filter.detail-filter-form :as filter-form]
            ))



(defn get-circle []
  (js/google.maps.Circle.
    (clj->js {:fillOpacity   0.1,
              :strokeColor   "#FF0000"
              :strokeOpacity 0.8
              :strokeWeight  2})))

(defn get-mainMarker []
  (js/google.maps.Marker.
    (clj->js {:title "Suche"
              :color "blue"})))




(defn get-update-map-content [!marker gmap !search !filter !selected]
  (js/console.log "ttttttttttttttttttttttttttttttt get-update-map-content  : " (.getBounds gmap))
  (when (and gmap (.getBounds gmap))
    (let [bounds (.getBounds gmap)
          ne (.getNorthEast bounds)
          sw (.getSouthWest bounds)
          box {:ne-lat (.lat ne)
               :ne-lng (.lng ne)
               :sw-lat (.lat sw)
               :sw-lng (.lng sw)
               }
          query (merge box
                       (filter-form/get-filter-request-part-noAddFields !search !filter))
          ]
      (js/console.log "ttttttttttttttttttttttttttttttt get-update-map-content  : " (clj->js box) (count @!marker))
      (s-user/get-user-map-elements
        query
        (fn [elms]
          (doseq [[id m] @!marker]
            (.setMap m nil))
          (reset! !marker nil)
          ;(js/console.log "set marker  : " (count elms) " sel " @!selected)
          (let [markers (reduce (fn [c [_ u]] (let [marker (js/google.maps.Marker.
                                                             (clj->js (if (= "u" (get u "type"))
                                                                        {:title    (str (get u "vn") " " (get u "ln") " \n")
                                                                         :position (js/google.maps.LatLng. (get u "lat") (get u "lng"))
                                                                         :id       (get u "id")
                                                                         :icon     (if (= @!selected (get u "id")) "/custom/img/tmann16_sel.png" "/custom/img/tmann16.png")
                                                                         }
                                                                        {:title    (str (get u "cnt") " Personen")
                                                                         :position (js/google.maps.LatLng. (get u "lat") (get u "lng"))
                                                                         :id       (get u "id")
                                                                         :label    {:color "#000" :fontSize "12px", :fontWeight "600" :text (str (get u "cnt"))}
                                                                         :icon     "/custom/img/cluster32.png"})))]
                                                (.setMap marker gmap)
                                                (when (= "u" (get u "type")) (js/google.maps.event.addListener marker "click" #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] (get u "id"))))
                                                (assoc c (get u "id") marker)
                                                ))
                                {}
                                elms
                                )]
            ;(js/console.log "markers" markers)
            (reset! !marker markers)))
        ))))





(defn gmap-component [!st]
  (let [!search (r/cursor !st [:search])
        !centerMap (r/cursor !st [:center-map])
        !filter (r/cursor !st [:filter])
        !selected (r/cursor !st [:selected])
        !address-marker (r/cursor !st [:address-marker])
        !marker (atom {})
        ]
    ;(js/console.log "Mount gmap " @!search @!filter )
    (let [gmap (atom nil)
          options (clj->js {"center" vstate/MAP_CENTER
                            "zoom"   vstate/MAP_ZOOM})
          update (fn [& [parm parm2 new]]
                   (js/console.log "tttttttttttttttttt UPDATE !centerMap?" parm parm2 new (.getBounds (:map @gmap)))
                   (when (and new (:center-map new) (not-empty (:center-map new)))
                     (.setCenter (:map @gmap) (js/google.maps.LatLng. (:lat (:center-map new)) (:lng (:center-map new))))
                     (.setZoom (:map @gmap) (:zoom (:center-map new)))
                     (reset! !centerMap {})
                     )
                   (if (:lat @!address-marker)
                     (do
                       (.setMap (:mainMarker @gmap) (:map @gmap))
                       (.setPosition (:mainMarker @gmap) (js/google.maps.LatLng. (:lat @!address-marker) (:lng @!address-marker)))
                       (.setMap (:circle @gmap) (:map @gmap))
                       (.setCenter (:circle @gmap) (js/google.maps.LatLng. (:lat @!address-marker) (:lng @!address-marker)))
                       (.setRadius (:circle @gmap) (int (or (:radius @!address-marker) 5000)))

                       )
                     (when (:mainMarker @gmap) (.setMap (:mainMarker @gmap) nil)))

                   (get-update-map-content !marker (:map @gmap) !search !filter !selected))]


      ;(update)
      (add-watch !st :atom-change
                 (fn [k r o n]
                   (js/console.log "ttttt Watch trigger called" k o "->" n)
                   (when (or
                           (not= (:filter o) (:filter n))
                           (not= (:search o) (:search n))
                           (not= (:invalidate o) (:invalidate n))
                           (and (:center-map n) (not-empty (:center-map n)) (not= (:center-map o) (:center-map n)))
                           )
                     (when (:map @gmap)
                       ;(js/console.log "Watch trigger fired" n)
                       (update {} {} n)))))

      ;(add-watch !search :search-change (fn [k r o n]  (when (:map @gmap) (js/console.log "Watch trigger !search" n) (update {}))))

      ;;(add-watch !centerMap :centerMap-change (fn [k r o n] (js/console.log "Watch trigger !centerMap" n)))

      ;(js/console.log "Mount gmap watcher registered " @!search @!filter @!centerMap)


      (r/create-class
        {:reagent-render       (fn []
                                 @!search
                                 [:div#map-canvas {:style {:height "573px"}}])
         :component-did-mount  (fn [comp]
                                 (js/console.log "ttttt map :component-did-mount")
                                 (let [canvas (.getElementById js/document "map-canvas")
                                       gm (js/google.maps.Map. canvas options)]
                                   (reset! gmap {:map gm :mainMarker (get-mainMarker) :circle (get-circle)})
                                   (js/google.maps.event.addListener gm "dragend" update)
                                   (js/google.maps.event.addListener gm "zoom_changed" update)
                                   )
                                 (let [auto-complete (js/google.maps.places.Autocomplete.
                                                       (.getElementById js/document "google-Autocomplete")
                                                       #js {:componentRestrictions #js {:country (txt/txt :core :map_country)}})]
                                   (js/google.maps.event.addListener auto-complete "place_changed"
                                                                     (fn [p]
                                                                       (let [place (.getPlace auto-complete)]
                                                                         (js/console.log "address search " place))))
                                   (swap! !st assoc :autoCompleteObj auto-complete)
                                   )
                                 (update)
                                 )
         :component-did-update (fn [comp]
                                 (js/console.log "ttttt map :component-did-update")
                                 ;(update)
                                 )
         :display-name         "gmap-component"}))))



(def map-home gmap-component)


